import React from 'react';

function UserInstruction() {
  return (
    <div className="tv-aiTalk__panel-wrapper">
      <div className="tv-aiTalk__instruction-wrapper">
        <h5 className="tv-aiTalk__instruction-wrapper__content">
          TFV Al-Tolk{' '}
          <a
            className="tv-aiTalk__instruction-wrapper__content-url"
            href="https://ai.tolkformedlingvast.se/"
            target="_blank"
          >
            https://ai.tolkformedlingvast.se/
          </a>
        </h5>
        <h5 className="tv-aiTalk__instruction-wrapper__content">
          Spara ner TFV AI-Tolk till hemskärmen{' '}
          <a
            className="tv-aiTalk__instruction-wrapper__content-url"
            href="https://www.tolkformedlingvast.se/download/18.727d9b1e19464867ad338be5/1784725259751/Spara%20ner%20webb-app%20till%20hemsk%C3%A4rm.pdf"
            target="_blank"
          >
            Instruktion spara webb-app till hemskärm/
          </a>
        </h5>
        <h5 className="tv-aiTalk__instruction-wrapper__content">
          Användarinstruktioner för TFV Al-Tolk{' '}
          <a
            className="tv-aiTalk__instruction-wrapper__content-url"
            href="https://www.tolkformedlingvast.se/download/18.7d640096193901489845827b/1789725369001/Instruktion%20TFV%20AI-Tolk.pdf"
            target="_blank"
          >
            Instruktioner TFV AI-Tolk
          </a>
        </h5>
        <h5 className="tv-aiTalk__instruction-wrapper__content">
          För mer information kontakta{' '}
          <a
            className="tv-aiTalk__instruction-wrapper__content-url"
            href="mailto:info@tolkformedlingvast.se"
            target="_blank"
          >
            info@tolkformedlingvast.se
          </a>
        </h5>
      </div>
    </div>
  );
}

export default UserInstruction;
